export default {
    LOAD_DOWNLOAD_CATEGORIES (state, downloadcategories) {
        state.items = downloadcategories
    }
}